module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leftNav"
  }, [_c('router-link', {
    attrs: {
      "to": "/main"
    }
  }, [_c('div', {
    staticClass: "menuBtn",
    on: {
      "click": _vm.clickNavMenu
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.icons[0]))]), _vm._v("Home\n    ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "menuBtn",
    on: {
      "click": _vm.clickCampaign
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.icons[1]))]), _vm._v("Campaign\n  ")], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.viewNav()) ? _c('sub-nav', {
    attrs: {
      "clickNavMenu": _vm.clickNavMenu
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-604a489c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/LeftNav.vue
// module id = 851
// module chunks = 1